import {
    ICreateExamByEc,
    QualificationEvaluationCenter,
    QualificationInfo,
    CreateExamByEc,
    AssignExpertsToExam,
    ExamList,
    IExamDetails,
    FilteredExamStatus,
    ICreateExamApplicationByQec,
    CreateExamApplicationByQec,
    IUpdateExamApplicationByQec,
    UpdateExamApplicationByQec,
    QecQualification,
    ExamWithPaymentList,
    IExamWithPaymentDetails,
    IExamWithPaymentList,
} from '../../api/ApiClient';
import { INotification } from 'components';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import moment from 'moment';

const getInitTime = () => moment().set({ hour: 12, minute: 0, second: 0 }).add(1, 'days');

const initialState: State = {
    examList: null,
    qecs: null,
    qualificationInfos: null,
    qecQualificationInfos: null,
    examPaymentDetails: null,
    examDetails: null,
    examsPayment: null,
    qualificationId: '',
    examDate: getInitTime(),
    qualificationEvaluationCenterId: '',
    invitedExpertIds: [],
    committeeChairmanId: '',
    applicationsLimit: undefined,
};

export default createModel({
    state: initialState,
    reducers: {
        init(state: State, data: { qecs: QualificationEvaluationCenter[]; qualificationInfos: QualificationInfo[]; qecQualificationInfos: QecQualification[] | null; qualificationEvaluationCenterId: string }): State {
            return {
                ...state,
                ...data,
                qualificationId: '',
                invitedExpertIds: [],
                committeeChairmanId: '',
                applicationsLimit: undefined,
                examDate: getInitTime(),
            };
        },
        setQecQualifications(state: State, qecQualificationInfos: QecQualification[]): State {
            return { ...state, qecQualificationInfos };
        },
        setExams(state: State, examList: ExamList | null): State {
            return { ...state, examList };
        },
        setFormData(state: State, data: Partial<ICreateExamByEc>): State {
            return {
                ...state,
                ...data,
            };
        },
        setExperts(state: State, payload: { expertIds: string[]; chairmanId: string }): State {
            return {
                ...state,
                invitedExpertIds: [...payload.expertIds],
                committeeChairmanId: payload.chairmanId,
            };
        },
        setExamPayment(state, examsPayment: ExamWithPaymentList): State {
            return { ...state, examsPayment };
        },
        fetchExamDetails(state, examDetails: IExamDetails): State {
            return { ...state, examDetails };
        },
        fetchExamPaymentDetails(state, examPaymentDetails: IExamWithPaymentDetails): State {
            return { ...state, examPaymentDetails };
        },
    },
    effects: (dispatch: any) => ({
        async initAsync() {
            const qecs = await apiConnector.execApi(dispatch, apiClient => apiClient.getQecs(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
            if (!qecs || qecs.items.length === 0) return;
            const qualificationEvaluationCenterId = qecs.items[0].id;
            const qecQualificationInfos = await apiConnector.execApi(dispatch, apiClient => apiClient.getQecQualifications(qualificationEvaluationCenterId));
            dispatch({ type: 'experts/clean' });
            if (!qecQualificationInfos) return;
            this.init({
                qecs: qecs && qecs.items,
                qualificationEvaluationCenterId,
                qualificationInfos: qecQualificationInfos,
                qecQualificationInfos,
            });
        },
        async getQecQualificationsAsync(_, root: IRootState) {
            const qecQualificationInfos = await apiConnector.execApi(dispatch, apiClient => apiClient.getQecQualifications(root.exam.qualificationEvaluationCenterId));
            this.setQecQualifications(qecQualificationInfos);
        },
        async getExamsAsync(payload: IGetExamsList) {
            this.setExams(null);
            const exams = await apiConnector.execApi(dispatch, apiClient => apiClient.getExams(
                payload.qualificationIds,
                payload.examinationCenterIds,
                payload.filteredExamStatus,
                payload.from,
                payload.to,
                payload.page,
                payload.pageSize,
                payload.sortOrder,
                payload.sortField,
            ));
            this.setExams(exams);
        },
        async createAsync(data: ICreateExamByEc) {
            const nData = new CreateExamByEc({ ...data });

            const result = await apiConnector.execApi(dispatch, apiClient => apiClient.createExam(nData));
            if (result) {
                dispatch.notifications.addNotification([{ message: 'Экзамен успешно добавлен!', appearance: 'success' }] as INotification[]);
            }
            return result;
        },
        async fetchExamDetailsWithPaymentAsync(id: string) {
            const examPaymentDetails = await apiConnector.execApi(
                dispatch,
                apiClient => apiClient.getExamWithPayment(id),
            );

            this.fetchExamPaymentDetails(examPaymentDetails);
        },
        clearExamDetailsWithPayment() {
            this.fetchExamPaymentDetails(null);
        },
        async fetchExamsWithPaymentListAsync(payload: IGetExamsPayment) {
            const examWithPayment = await apiConnector.execApi(dispatch, apiClient => apiClient.getExamWithPaymentList(
                payload.paid,
                payload.qualificationIds,
                payload.examinationCenterIds,
                payload.from,
                payload.to,
                payload.page,
                payload.pageSize,
                payload.sortOrder,
                payload.sortField,
            ));

            this.setExamPayment(examWithPayment);
        },
        async fetchExamDetailsAsync(id: string) {
            const examDetails = await apiConnector.execApi(
                dispatch,
                apiClient => apiClient.getExam(id),
            );

            this.fetchExamDetails(examDetails);
        },
        async assignExpertsToExamAsync({ examId, body }: IAssignExpertsToExam) {
            const result = await apiConnector.execApi(dispatch, apiClient => apiClient.assignExpertsToExam(examId, body));
            if (result) {
                dispatch.notifications.addNotification([{ message: 'Эксперты успешно добавлены!', appearance: 'success' }] as INotification[]);
            }
        },
        async createExamApplicationDraftAsync(body: ICreateExamApplicationByQec) {
            const result = await apiConnector.execApi(dispatch, apiClient => apiClient.createExamApplicationDraft(new CreateExamApplicationByQec(body)));
            if (result) {
                dispatch.notifications.addNotification([{ message: 'Черновик успешно добавлен!', appearance: 'success' }] as INotification[]);
            }

            return result;
        },
        async updateExamApplicationDraftAsync(data: IUpdateDraft) {
            const result = await apiConnector.execApi(dispatch, apiClient => apiClient.updateExamApplicationDraft(
                data.examApplicationId,
                new UpdateExamApplicationByQec(data.body),
            ));
            if (result) {
                dispatch.notifications.addNotification([{ message: 'Черновик успешно обновлен!', appearance: 'success' }] as INotification[]);
            }

            return result;
        },
        async deleteExamApplicationDraftAsync(examApplicationId: string) {
            const result = await apiConnector.execApi(dispatch, apiClient => apiClient.deleteExamApplicationDraft(examApplicationId));
            if (result) {
                dispatch.notifications.addNotification([{ message: 'Черновик успешно удален!', appearance: 'success' }] as INotification[]);
            }

            return result;
        },
    }),
});

interface IAssignExpertsToExam {
    examId: string;
    body: AssignExpertsToExam;
}

export interface IGetExamsList {
    qualificationIds?: string[];
    examinationCenterIds?: string[];
    qecIds?: string[];
    filteredExamStatus?: FilteredExamStatus | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface IUpdateDraft {
    examApplicationId: string;
    body: IUpdateExamApplicationByQec;
}

interface State extends ICreateExamByEc {
    examList: ExamList | null;
    qecs: QualificationEvaluationCenter[] | null;
    qualificationInfos: QualificationInfo[] | null;
    qecQualificationInfos: QecQualification[] | null;
    examsPayment: IExamWithPaymentList | null;
    examDetails: IExamDetails | null;
    examPaymentDetails: IExamWithPaymentDetails | null;
    qualificationEvaluationCenterId: string;
}

interface IRootState {
    exam: State;
}


interface IGetExamsPayment {
    paid?: boolean | undefined;
    qualificationIds?: string[];
    examinationCenterIds?: string[];
    page?: number;
    pageSize?: number;
    sortOrder?: boolean | undefined;
    sortField?: string;
    to?: moment.Moment;
    from?: moment.Moment;
}
